import { render, staticRenderFns } from "./MaterialStatsCardS.vue?vue&type=template&id=15128416"
import script from "./MaterialStatsCardS.vue?vue&type=script&lang=js"
export * from "./MaterialStatsCardS.vue?vue&type=script&lang=js"
import style0 from "./MaterialStatsCardS.vue?vue&type=style&index=0&id=15128416&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports